<template>
    <div class="comment">
        <span class="text-center w-100 p-2" style="display: block" v-if="delay">
            <b-spinner label="Spinning"/>
        </span>
        <span v-else>
            <ul class="comment-container list-unstyled">
				<transition-group name="list">
					<b-media tag="li" v-for="item in items" :key="item.id" :comment-id="item.id" class="comment-item">
						<template v-slot:aside>
                            <b-avatar variant="default" :src="item.image" :text="item.name | namegr" size="3rem"/>
						</template>
						<h5 class="mt-0 mb-1">
							<router-link :to="'/address/'+ item.from"><b>{{ item.name ? item.name : item.from.slice(0, 20) + '...' }}</b></router-link> <small class="text-muted"><i class="fal fa-clock"/> <time-ago :refresh="1" long :locale="$i18n.locale" :datetime="item.timestamp * 1000" :tooltip="true"/></small>
							<span class="float-right" v-if="item.delete">
								<b-button @click="deleteComment(item.id, item.type)" variant="light"><i class="far fa-times-circle text-secondary"/></b-button>
							</span>
						</h5>
						<p class="mb-0 text-wrap text-break">
							{{ item.text }}
						</p>
					</b-media>
				</transition-group>
            </ul>
            <span class="comment-more" v-if="more.show">
                <b-button @click="getMore" class="w-100" variant="light">
                    <b-spinner v-if="more.loading" small /><b-badge v-else class="text-secondary" variant="light"><i class="fad fa-hand-point-down"/> {{ count - items.length }}</b-badge>
                </b-button>
            </span>
            <div v-if="$store.state.logget" class="comment-form">
                <b-overlay :show="form.delay" rounded="lg" opacity="0.6">
                    <template v-slot:overlay>
                        <div class="d-flex align-items-center">
                            <b-spinner small type="grow" variant="primary"></b-spinner>
                            <b-spinner type="grow" variant="primary"></b-spinner>
                            <b-spinner small type="grow" variant="primary"></b-spinner>
                            <span class="sr-only">Please wait...</span>
                        </div>
                    </template>
                    <b-form-textarea class="form-textarea overflow-hidden" :disabled="form.delay" v-on:keyup.enter="setComment" :no-resize="true" v-model="text" rows="2" :placeholder="$t('default.ln_2')"/>
                </b-overlay>
                <span class="emoji-dialog">
                    <span class="emoji-smile" @click="form.dialog = !form.dialog">
                        <i class="fal fa-smile-wink"/>
                    </span>
                </span>

				<!-- Modal box emoji list. -->
                <VEmojiPicker style="margin-top: -2px;" v-show="form.dialog" :labelSearch="$t('default.ln_0')" :i18n="$i18n.locale" @select="emoji"/>
            </div>
        </span>
    </div>
</template>

<script lang="js">

    import api 				from '../libs/api';
    import axios 			from 'axios';
	import { VEmojiPicker } from 'v-emoji-picker';
    import TimeAgo 			from 'vue2-timeago';

	const STATUS_OK = "OK";

    export default {
        name: "comment",
        components: {
			VEmojiPicker,
            TimeAgo
        },
        props: {
            scopeType: {
                type: String
            },
            scopeMaster: {
                type: String
            },
            scopeParent: {
                type: Number
            }
        },
        data() {
            return {
                type: this.$props.scopeType,
                master: this.$props.scopeMaster,
                parent: this.$props.scopeParent,
                message: {
                    id: 0,
                    name: null,
                    from: null,
                    parent: null,
					image: null,
                    type: null,
                    text: null,
                    delete: true,
                    timestamp: 0
                },
                form: {
                    dialog: false,
                    delay: false
                },
                more: {
                    show: false,
                    loading: false
                },
                items: [],
                text: "",
				delay: false,
                count: 0
            }
        },
        created() {
            this.getComment(0)
        },
        methods: {
            emoji(emoji) {
                this.$data.text += emoji.data;
            },
            getMore() {
                this.getComment(this.$data.items[this.$data.items.length - 1].id)
            },
            getComment(last) {

                if (last) {
                    this.$data.more.loading = true;
                } else {
                    this.$data.delay = true;
                }

                axios.post(api.message.list, {parent: this.$data.parent, type: this.$data.type, last: last}).then((response) => {

                    this.$store.dispatch('getLocalStorageObject', 'account').then(async (account) => {

                        if (!last) {
                            this.$data.items = [];
                        }

                        if (response.data.source !== undefined) {
                            this.$data.count = response.data.count;

                            for (let i = 0; i < response.data.source.length; i++) {

								await this.$storage("account",  response.data.source[i].from, response.data.source[i].image).then((response) => {
									this.$data.message.image = response;
								});

                                this.$data.message.id = response.data.source[i].id;
                                this.$data.message.name = response.data.source[i].name;
                                this.$data.message.from = response.data.source[i].from;
                                this.$data.message.to = this.$data.master;
                                this.$data.message.parent = response.data.source[i].parent;
                                this.$data.message.text = response.data.source[i].text;
                                this.$data.message.type = response.data.source[i].type;
                                this.$data.message.timestamp = response.data.source[i].timestamp;
                                this.$data.message.delete = true;

                                if (account) {
                                    if (account.address === this.$data.master) {
                                        this.$data.message.delete = true;
                                    } else {
                                        this.$data.message.delete = account.address === response.data.source[i].from;
                                    }
                                } else {
                                    this.$data.message.delete = false;
                                }

                                this.$data.items.push(Object.assign({}, this.$data.message));
                            }

                            this.$data.more.show = this.$data.count > this.$data.items.length;
                        }

                        if (last) {
                            this.$data.more.loading = false;
                        } else {
                            this.$data.delay = false;
                        }
                    });

                }).catch((error) => {
					this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
						title: this.$t('error.ln_5'),
						autoHideDelay: 5000,
						toaster: 'b-toaster-bottom-right',
						variant: 'danger',
					});
                });
            },
            setComment() {
                if (this.$data.text) {

                    this.$data.form.delay = true;

                    axios.post(api.message.send, {
						to: this.$data.master,
						parent: this.$data.parent,
						text: this.$data.text,
						type: this.$data.type,
						poll: {component: false}
                    }).then(async (response) => {

						await this.$storage("account",  response.data.source[0].from, response.data.source[0].image).then((response) => {
							this.$data.message.image = response;
						});

                        this.$data.message.id = response.data.source[0].id;
                        this.$data.message.name = response.data.source[0].name;
                        this.$data.message.from = response.data.source[0].from;
                        this.$data.message.to = this.$data.master;
                        this.$data.message.parent = response.data.source[0].parent;
                        this.$data.message.text = response.data.source[0].text;
                        this.$data.message.type = response.data.source[0].type;
                        this.$data.message.delete = true;
                        this.$data.message.timestamp = response.data.source[0].timestamp;

                        this.$data.items.push(Object.assign({}, this.$data.message));

                        if (this.$data.more.show) {
                            this._.delay(() => {
                                this.$data.items.splice(this._.findKey(this.$data.items, {id: this.$data.message.id}), 1);
                                this.$data.count += 1
                            }, 1000)
                        } else {
                            this.$data.count += 1
                        }

                        this.$data.text = "";
                        this.$data.form.dialog = false;

                        this._.delay(() => {
                            this.$data.form.delay = false;
                        }, 1000)

                    }).catch((error) => {
                        this._.delay(() => {
                            this.$data.form.delay = false;
                        }, 1000)
						this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
							title: this.$t('error.ln_5'),
							autoHideDelay: 5000,
							toaster: 'b-toaster-bottom-right',
							variant: 'danger',
						});
                    });
                } else {
					this.$bvToast.toast(`${this.$t('error.ln_6')}`, {
						title: this.$t('error.ln_5'),
						autoHideDelay: 5000,
						toaster: 'b-toaster-bottom-right',
						variant: 'danger',
					});
                }
            },
            deleteComment(id, type) {
                axios.post(api.message.delete, {id: id, type: type}).then((response) => {
					if (response.data.status === STATUS_OK) {
                        this.$data.items.splice(this._.findKey(this.$data.items, {id: id}), 1);
                        this.$data.count -= 1
                        if (this.$data.items.length === 1) {
                            this.getMore()
                        }
                    }
                }).catch((error) => {
					this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
						title: this.$t('error.ln_5'),
						autoHideDelay: 5000,
						toaster: 'b-toaster-bottom-right',
						variant: 'danger',
					});
                });
            }
        }
    }
</script>

<style scoped>

    .comment {
        overflow: hidden;
        background-color: white;
    }

    .comment > span > .comment-form {
        padding: 1.25rem;
    }

    .comment > span > .comment-form .form-textarea {
        padding-left: 46px;
        height: 40px;
        border-radius: 5px;
    }

    .comment > span > .comment-form > .emoji-dialog {
        position: absolute;
        margin: -37px 0 0 0;
    }

    .comment > span > .comment-form > .emoji-dialog > .emoji-smile {
        height: 25px;
        line-height: 30px;
        margin: 5px;
        padding: 0 8px;
        border-right: 1px solid #ddd;
        display: block;
    }

    .comment > span > .comment-form > .emoji-dialog > .emoji-smile > .fa-smile-wink {
        font-size: 20px;
    }

    .comment > span > .comment-container {
        margin-bottom: 0;
    }

    .comment > span > .comment-container .comment-item {
        border-bottom: 1px solid #eceaea;
        padding: 1.25rem;
    }

    .comment > span > .comment-more {
        padding: 1.25rem;
        display: block;
        border-bottom: 1px solid #eceaea;
    }

</style>